export var MUTUAL_FUNDS_SCHEMES = "MUTUAL_FUNDS_SCHEMES";
export var MUTUAL_FUNDS_SCHEMES_UPDATE = "MUTUAL_FUNDS_SCHEMES_UPDATE";
export var MUTUAL_FUNDS_SCHEMES_APPLY_SORT = "MUTUAL_FUNDS_SCHEMES_APPLY_SORT";
export var MUTUAL_FUNDS_SCHEMES_UPDATE_SORTED_DATA = "MUTUAL_FUNDS_SCHEMES_UPDATE_SORTED_DATA";
export var MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA = "MUTUAL_FUNDS_SCHEMES_UPDATE_SEARCH_DATA";
export var MUTUAL_FUNDS_SCHEMES_UPDATE_MSG = "MUTUAL_FUNDS_SCHEMES_UPDATE_MSG";
export var MUTUAL_FUNDS_SCHEMES_CLEAR_MSG = "MUTUAL_FUNDS_SCHEMES_CLEAR_MSG";
export var MUTUAL_FUNDS_SCHEMES_CLEAR_SORT = "MUTUAL_FUNDS_SCHEMES_CLEAR_SORT";
export var MUTUAL_FUNDS_SCHEMES_ERROR = "MUTUAL_FUNDS_SCHEMES_ERROR";
export var MUTUAL_FUNDS_SCHEMES_HIDE_ERROR = "MUTUAL_FUNDS_SCHEMES_HIDE_ERROR";
export var MUTUAL_FUNDS_SCHEMES_START_LOADER = "MUTUAL_FUNDS_SCHEMES_START_LOADER";
export var MUTUAL_FUNDS_SCHEMES_STOP_LOADER = "MUTUAL_FUNDS_SCHEMES_STOP_LOADER";
export var MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER = "MUTUAL_FUNDS_SCHEMES_TABLE_START_LOADER";
export var MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER = "MUTUAL_FUNDS_SCHEMES_TABLE_STOP_LOADER";
export var MUTUAL_FUNDS_SCHEMES_PARAMS = "MUTUAL_FUNDS_SCHEMES_PARAMS";
export var MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA = "MUTUAL_FUNDS_SCHEMES_CLEAR_SEARCH_DATA";
export var MUTUAL_FUNDS_CLEAR_SCHEMES_DATA = "MUTUAL_FUNDS_CLEAR_SCHEMES_DATA";
